import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X, AlertCircle } from 'lucide-react';

interface ToastProps {
  show: boolean;
  message: string;
  type: 'success' | 'error';
  onClose: () => void;
  position?: 'top' | 'bottom';
}

const Toast: React.FC<ToastProps> = ({ show, message, type, onClose, position = 'top' }) => {
  const positionClasses = position === 'top' 
    ? '-top-16' 
    : '-bottom-16';

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: position === 'top' ? -20 : 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: position === 'top' ? -20 : 20 }}
          className={`absolute ${positionClasses} left-1/2 transform -translate-x-1/2 z-50 px-6 py-3 rounded-lg shadow-lg flex items-center ${
            type === 'success' ? 'bg-green-500' : 'bg-red-500'
          } text-white w-[90%] max-w-md`}
        >
          {type === 'success' ? (
            <CheckCircle2 className="h-5 w-5 mr-2 flex-shrink-0" />
          ) : (
            <AlertCircle className="h-5 w-5 mr-2 flex-shrink-0" />
          )}
          <span className="flex-grow text-sm">{message}</span>
          <button
            onClick={onClose}
            className="ml-4 hover:text-white/80 transition-colors flex-shrink-0"
          >
            <X className="h-5 w-5" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Toast;